// @flow
import usePermissions from 'hooks/usePermissions'
import * as React from 'react'
import Dropdown, { type DropdownItem } from 'ui/atoms/Dropdown'

import FormControlsDropdownMenuDeleteButton from './FormControlsDropdownMenuDeleteButton'
import FormControlsDropdownMenuDisableButton from './FormControlsDropdownMenuDisableButton'
import FormControlsDropdownMenuTrigger from './FormControlsDropdownMenuTrigger'

type Props = {
  isPacket?: boolean,
  resourceEnabled: boolean,
  measuresEnabled: boolean,
  resourceId: string | number,
  resourceType: 'form' | 'packet' | 'pdf',
  setLoading: (loading: boolean) => void,
}

function FormControlsDropdownMenu({
  isPacket,
  resourceEnabled,
  measuresEnabled,
  resourceId,
  resourceType,
  setLoading,
}: Props): React.Node {
  const { canDisablePacketForm, canEditPacketForm, canDeletePacketForm } =
    usePermissions()

  const menuItems = React.useMemo(() => {
    const items: DropdownItem[] = []

    if (canDisablePacketForm) {
      items.push({
        key: 'disable',
        label: (
          <FormControlsDropdownMenuDisableButton
            isPacket={isPacket}
            resourceEnabled={resourceEnabled}
            resourceId={resourceId}
            resourceType={resourceType}
            setLoading={setLoading}
          />
        ),
      })
    }

    if (canDeletePacketForm) {
      items.push({
        key: 'delete',
        label: (
          <FormControlsDropdownMenuDeleteButton
            isPacket={isPacket}
            measuresEnabled={measuresEnabled}
            resourceEnabled={resourceEnabled}
            resourceId={resourceId}
            resourceType={resourceType}
            setLoading={setLoading}
          />
        ),
      })
    }

    return items
  }, [
    canDeletePacketForm,
    canDisablePacketForm,
    isPacket,
    resourceEnabled,
    resourceId,
    resourceType,
    setLoading,
    measuresEnabled,
  ])

  if (!canEditPacketForm && !canDeletePacketForm && !canDisablePacketForm) {
    return null
  }

  return (
    <div>
      <Dropdown
        items={menuItems}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div>
          <FormControlsDropdownMenuTrigger enabled={resourceEnabled} />
        </div>
      </Dropdown>
    </div>
  )
}

export default FormControlsDropdownMenu
